import { ButtonLink, DRAWER_WIDTH } from '@toggle/design-system';
import React, { ReactNode } from 'react';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';

import styles from './ExpandableDrawer.module.scss';
import * as S from './ExpandableDrawer.styles';

const EXPANDED_VALUE = '1';

export type ExpandableDrawerProps = {
  isOpen: boolean;
  handleCloseClick: () => void;
  headerButton?: ReactNode;
  subHeaderNode?: ReactNode;
  children: ReactNode;
  fullViewContent: ReactNode;
  defaultWidth?: number;
  label: ReactNode;
};

export const ExpandableDrawer = ({
  isOpen,
  handleCloseClick,
  headerButton,
  subHeaderNode,
  children,
  fullViewContent,
  defaultWidth = DRAWER_WIDTH,
  label,
}: ExpandableDrawerProps) => {
  const { params, setQueryParams } = useQueryParams();
  const isExpanded = params[queryKeys.drawerExpanded] === EXPANDED_VALUE;

  const handleExpand = () => {
    setQueryParams({ [queryKeys.drawerExpanded]: EXPANDED_VALUE });
  };

  //TODO: add subheader node

  return (
    <S.StyledDrawer
      $isExpanded={isExpanded}
      $defaultWidth={defaultWidth}
      isOpen={isOpen}
      handleCloseClick={handleCloseClick}
      headerButton={
        <div className={styles.FlexWrapper}>
          <div className={styles.headerButtons}>
            {!isExpanded && (
              <div className={styles.floatButtonWrapper}>
                <ButtonLink
                  label={label}
                  onClick={handleExpand}
                  iconName="ChevronDoubleLeft"
                  iconSize={16}
                  iconViewBox="0 0 12 12"
                  className={styles.floatButton}
                />
              </div>
            )}
            {headerButton}
          </div>
          {isExpanded && subHeaderNode}
        </div>
      }
    >
      {isExpanded ? (
        <div className={styles.fullViewWrapper}>
          <div className={styles.leftPanel}>{fullViewContent}</div>
          <div className={styles.rightPanel}>{children}</div>
        </div>
      ) : (
        children
      )}
    </S.StyledDrawer>
  );
};
